import { render, staticRenderFns } from "./SpecimenResultView.vue?vue&type=template&id=7feb0a5a&scoped=true&"
import script from "./SpecimenResultView.vue?vue&type=script&lang=js&"
export * from "./SpecimenResultView.vue?vue&type=script&lang=js&"
import style0 from "./SpecimenResultView.vue?vue&type=style&index=0&id=7feb0a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7feb0a5a",
  null
  
)

export default component.exports